import { Box, Menu, MenuItem } from "@mui/material";
import React, { useMemo, useState, useRef } from "react";
import { Tab, Tabs } from "@mui/material";
import {
  People,
  Assessment as AssessmentIcon,
  Gavel,
  ReceiptLong,
  AlternateEmail,
  Paid,
  CurrencyExchange,
  FileUpload,
  BarChart,
  ManageAccounts,
  Groups,
} from "@mui/icons-material";
import { MembersTab } from "./tabs/MembersTab";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { AssessmentTab } from "./tabs/assessmentTab/AssessmentTab";
import { InvoicesTab } from "./tabs/invoicesTab/InvoicesTab";
import { PaymentsTab } from "./tabs/paymentsTab/PaymentsTab";
import { PremiumsTab } from "./tabs/premiumsTab/PremiumsTab";
import { RefundsTab } from "./tabs/RefundsTab/RefundsTab";
import { naicMemberRoleCheck } from "../shared/utils/permissions";
import { useDispatch, useSelector } from "react-redux";
import { InsolventTab } from "./tabs/insolventTab/InsolventTab";
import { CommunicationTab } from "./tabs/communicationTab/CommunicationTab";
import { setActiveTab, setInvoiceNumber } from "../store/slices/FilterSlice";
import RoleAssignmentPage from "./roleAssignmentPage/RoleAssignmentPage";
import MemberGroupsPage from "./memberGroupsPage/MemberGroupsPage";

export const TabPage = ({tab}) => {

  const roleId = useSelector((state) => state?.user?.roleId);
  const { activeTab } = useSelector(
    (state) => state.filter
  );
  const dispatch = useDispatch();

  const onRedirect =(type, value)=>{
    switch (type) {
      case 'invoices':
        dispatch(setActiveTab(3));
        break;
      default:
        dispatch(setActiveTab(5));
    dispatch(setInvoiceNumber(value));

        break;
    }

    setTimeout(() => {
    dispatch(setInvoiceNumber(value));
      
    },0);

  }

  const tabs = naicMemberRoleCheck(roleId) ? [
    { label: 'Members', component: <MembersTab /> },
    { label: 'Assessments', component: <AssessmentTab /> },
    { label: 'Insolvents', component: <InsolventTab /> },
    { label: 'Invoices', component: <InvoicesTab onRedirect={onRedirect}/> },
    { label: 'Payments', component: <PaymentsTab onRedirect={onRedirect}/> },
  { label: 'Premiums', component: <PremiumsTab /> },
    { label: 'Communication', component: <CommunicationTab /> },
    //{ label: 'Refunds', component: <RefundsTab /> },
    //{ label: 'Imports', component: <div>Imports content</div> },
    { label: 'User Management', component: <RoleAssignmentPage /> },
    { label: 'Group Management', component: <MemberGroupsPage /> },
   // { label: 'Reports', component: <div /> },
  ] : [
    { label: 'Members', component: <MembersTab /> },
    { label: 'Invoices', component: <InvoicesTab onRedirect={onRedirect}/> },
    { label: 'Payments', component: <PaymentsTab onRedirect={onRedirect}/> },
  ]

  // Reports menu handling
  const [reportsAnchorEl, setReportsAnchorEl] = useState(null);
  const reportsIndex = tabs.findIndex(t => t.label === 'Reports');
  const openReportsMenu = Boolean(reportsAnchorEl);

  const handleOpenReports = (anchorTarget) => {
    setReportsAnchorEl(anchorTarget);
  };
  const handleCloseReports = () => setReportsAnchorEl(null);

  const openReportLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    handleCloseReports();
  };

  const onTabChange = (event, newValue) => {
    if (newValue === reportsIndex) {
      // Do not change active tab, just open menu
      handleOpenReports(event.currentTarget);
      return;
    }
    dispatch(setActiveTab(newValue));
  };

  return (
    <>
      <AuthenticatedTemplate>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: "22px" }}>
          <Tabs
            value={activeTab}
            onChange={onTabChange}
            aria-label="tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((tab, index) => {
              const icon = (() => {
                switch (tab.label) {
                  case 'Members':
                    return <People fontSize="small" />;
                  case 'Assessments':
                    return <AssessmentIcon fontSize="small" />;
                  case 'Insolvents':
                    return <Gavel fontSize="small" />;
                  case 'Invoices':
                    return <ReceiptLong fontSize="small" />;
                  case 'Communication':
                    return <AlternateEmail fontSize="small" />;
                  case 'Payments':
                    return <Paid fontSize="small" />;
                  case 'Premiums':
                    return <CurrencyExchange fontSize="small" />;
                  case 'Refunds':
                    return <CurrencyExchange fontSize="small" />;
                  case 'Imports':
                    return <FileUpload fontSize="small" />;
                  case 'Reports':
                    return <BarChart fontSize="small" />;
                  case 'User Management':
                    return <ManageAccounts fontSize="small" />;
                  case 'Group Management':
                    return <Groups fontSize="small" />;
                  default:
                    return null;
                }
              })();
              return (
                <Tab
                  key={index}
                  label={tab.label}
                  value={index}
                  icon={icon}
                  iconPosition="start"
                  sx={{ minHeight: "48px", maxWidth: "700px" }}
                />
              );
            })}
          </Tabs>

          {reportsIndex > -1 && (
            <Menu
              anchorEl={reportsAnchorEl}
              open={openReportsMenu}
              onClose={handleCloseReports}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              <MenuItem onClick={() => openReportLink('https://app.powerbi.com/groups/17de80d1-c228-4727-8b60-4f42eb7649dd/reports/cd95a26b-d99d-424f-b7f7-0f896df185db/9dfb3ba70c5407720e03?experience=power-bi')}>Assessments</MenuItem>
              <MenuItem onClick={() => openReportLink('https://app.powerbi.com/groups/c8579554-8a51-4f70-b535-eca47c9e699f/reports/046a7f9c-8d13-401d-90ca-ad1dcf8a1697/73b4fa8a1f0227f9fc6f?experience=power-bi')}>Members</MenuItem>
              <MenuItem onClick={() => openReportLink('https://app.powerbi.com/groups/17de80d1-c228-4727-8b60-4f42eb7649dd/reports/cd95a26b-d99d-424f-b7f7-0f896df185db/9dfb3ba70c5407720e03?experience=power-bi')}>Premiums</MenuItem>
            </Menu>
          )}

          <Box mt={3} key={activeTab}>
            {/* For Reports, keep showing previously active content since Reports opens a menu only */}
            {activeTab !== reportsIndex && tabs[activeTab]?.component}
          </Box>
        </Box>
      </AuthenticatedTemplate>
    </>
  );
};
